<template>
  <div class="system-menu">
    <ul>
      <li class="system-menu-title">Hesap Yönetimi</li>

      <li
        v-for="(table, index) in $root.cache.tables"
        v-if="table.location == 2"
      >
        <template v-if="table.url">
          <router-link
            class="url-flex"
            :class="{
              'active-url font-medium': $route.params.index == index
            }"
            :to="{ name: table.url, params: { index } }"
          >
            <vk-icon ratio="1" class="opacity-40" :icon="table.icon"></vk-icon>
            <span>{{ table.name }}</span>
          </router-link>
        </template>
        <template v-else>
          <router-link
            class="url-flex"
            :class="{
              'active-url font-medium': $route.params.index == index
            }"
            :to="{ name: 'adminDetail', params: { index, table: table.table } }"
          >
            <vk-icon ratio="1" class="opacity-40" :icon="table.icon"></vk-icon>
            <span>{{ table.name }}</span>
          </router-link>
        </template>
      </li>
      <li class="system-menu-title">Satış süreci özelleştirme</li>
      <li
        v-for="(table, index) in $root.cache.tables"
        v-if="table.location == 3"
      >
        <template v-if="table.url">
          <router-link
            class="url-flex"
            :class="{
              'active-url font-medium': $route.params.index == index
            }"
            :to="{ name: table.url, params: { index } }"
          >
            <vk-icon ratio="1" class="opacity-40" :icon="table.icon"></vk-icon>
            <span>{{ table.name }}</span>
          </router-link>
        </template>
        <template v-else>
          <router-link
            class="url-flex"
            :class="{
              'active-url font-medium': $route.params.index == index
            }"
            :to="{ name: 'adminDetail', params: { index, table: table.table } }"
          >
            <vk-icon ratio="1" class="opacity-40" :icon="table.icon"></vk-icon>
            <span>{{ table.name }}</span>
          </router-link>
        </template>
      </li>
      <li class="system-menu-title">Raporlar</li>

      <li
        v-for="(table, index) in $root.cache.tables"
        v-if="table.location == 4"
      >
        <template v-if="table.url">
          <router-link
            class="url-flex"
            :class="{
              'active-url font-medium': $route.params.index == index
            }"
            :to="{ name: table.url, params: { index } }"
          >
            <vk-icon ratio="1" class="opacity-40" :icon="table.icon"></vk-icon>
            <span>{{ table.name }}</span>
          </router-link>
        </template>
        <template v-else>
          <router-link
            class="url-flex"
            :to="{ name: 'adminDetail', params: { index, table: table.table } }"
          >
            <vk-icon ratio="1" class="opacity-40" :icon="table.icon"></vk-icon>
            <span>{{ table.name }}</span>
          </router-link>
        </template>
      </li>

      <!-- Dinamik Rapor Kategorileri -->
      <template v-for="category in reportCategories">
        <li class="system-menu-subtitle" :key="'cat-' + category.id">
          <span class="text-xs uppercase text-gray-500 font-medium">{{ category.name }}</span>
        </li>
        <li v-for="report in category.reports" :key="'report-' + report.id">
          <router-link
            class="url-flex"
            :class="{
              'active-url font-medium': $route.query.report_id == report.id
            }"
            :to="{ name: 'reports', query: { category_id: category.id, report_id: report.id } }"
          >
            <vk-icon ratio="1" class="opacity-40" icon="file-text"></vk-icon>
            <span>{{ report.name }}</span>
          </router-link>
        </li>
      </template>

      <!-- Rapor Kategorileri Yönetimi -->
      <li v-if="isAdminUser">
        <router-link
          class="url-flex"
          :class="{
            'active-url font-medium': $route.name === 'adminReportCategories'
          }"
          :to="{ name: 'adminReportCategories' }"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 opacity-40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
          </svg>
          <span>Rapor Kategorileri</span>
        </router-link>
      </li>

      <li class="system-menu-title">Sistem Ayarları</li>
      <li v-if="canSeeServerInfo">
        <router-link
          class="url-flex"
          :class="{ 'active-url font-medium': $route.name === 'admin-info' }"
          :to="{ name: 'admin-info' }"
        >
          <vk-icon ratio="1" class="opacity-40" icon="server"></vk-icon>
          <span>Sunucu Durumu</span>
        </router-link>
      </li>
      <li v-if="isAdminUser">
        <router-link
          class="url-flex"
          :class="{ 'active-url font-medium': $route.name === 'admin-api-keys' }"
          :to="{ name: 'admin-api-keys' }"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 opacity-40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
          <span>API Keys</span>
        </router-link>
      </li>
      <li>
        <router-link
          class="url-flex"
          :class="{ 'active-url font-medium': $route.name === 'admin-timezone' }"
          :to="{ name: 'admin-timezone' }"
        >
          <vk-icon ratio="1" class="opacity-40" icon="world"></vk-icon>
          <span>Timezone</span>
        </router-link>
      </li>
      <li v-if="isAdminUser">
        <router-link
          class="url-flex"
          :class="{ 'active-url font-medium': $route.name === 'excel-bulk-fixer' }"
          :to="{ name: 'excel-bulk-fixer' }"
        >
          <vk-icon ratio="1" class="opacity-40" icon="file-edit"></vk-icon>
          <span>Excel Toplu Düzeltme</span>
        </router-link>
      </li>
      <li v-if="isAdminUser">
        <router-link
          class="url-flex"
          :class="{ 'active-url font-medium': $route.name === 'admin-field-manager' }"
          :to="{ name: 'admin-field-manager' }"
        >
          <vk-icon ratio="1" class="opacity-40" icon="list"></vk-icon>
          <span>Alan Siralama</span>
        </router-link>
      </li>
      <!-- Duplicate Leads Raporu -->
      <li>
        <router-link
          class="url-flex"
          :class="{
            'active-url font-medium': $route.path === '/report/duplicate-leads'
          }"
          to="/report/duplicate-leads"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 opacity-40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
            <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
            <path d="M9 14l2 2 4-4"/>
          </svg>
          <span>Duplicate Leads</span>
        </router-link>
      </li>
      <!-- Data Kaynağı Performans Paneli -->
      <li>
        <router-link
          class="url-flex"
          :class="{ 'active-url font-medium': $route.path === '/report/source-performance' }"
          to="/report/source-performance"
        >
          <vk-icon ratio="1" class="opacity-40" icon="database"></vk-icon>
          <span>Data Kaynağı Performans</span>
        </router-link>
      </li>
      <!-- Satışçı x Data Kaynağı Matrisi -->
      <li>
        <router-link
          class="url-flex"
          :class="{ 'active-url font-medium': $route.path === '/report/agent-source-matrix' }"
          to="/report/agent-source-matrix"
        >
          <vk-icon ratio="1" class="opacity-40" icon="table"></vk-icon>
          <span>Satışçı x Kaynak Matrisi</span>
        </router-link>
      </li>
      <!-- Boşta Kalan Data Raporu -->
      <li>
        <router-link
          class="url-flex"
          :class="{ 'active-url font-medium': $route.path === '/report/idle-leads' }"
          to="/report/idle-leads"
        >
          <vk-icon ratio="1" class="opacity-40" icon="clock"></vk-icon>
          <span>Boşta Kalan Data</span>
        </router-link>
      </li>
      <!-- Retention-Satış Raporu -->
      <li v-if="canSeeRetentionSalesReport">
        <router-link
          class="url-flex"
          :class="{ 'active-url font-medium': $route.path === '/report/retention-report-sales' }"
          to="/report/retention-report-sales"
        >
          <vk-icon ratio="1" class="opacity-40" icon="credit-card"></vk-icon>
          <span>Retention-Satış Raporu</span>
        </router-link>
      </li>
      <li>
        <a href="#" @click="resetCache()">Reset Cache</a>
      </li>
    </ul>
  </div>
</template>

<script>
import http from "@/services/http";

export default {
  data() {
    return {
      reportCategories: []
    };
  },
  computed: {
    isAdminUser() {
      const cache = this.$root.cache || {};
      const me = cache.me || JSON.parse(localStorage.getItem("me") || "{}");
      return ["admin", "admin1", "admin2"].includes(me.department);
    },
    // API'deki admin middleware'i ile aynı küme (admin1 yok).
    canSeeServerInfo() {
      const cache = this.$root.cache || {};
      const me = cache.me || JSON.parse(localStorage.getItem("me") || "{}");
      return ["admin", "admin2"].includes(me.department);
    },
    canSeeRetentionSalesReport() {
      const cache = this.$root.cache || {};
      const me = cache.me || {};
      return ["admin", "admin1", "admin2", "sales_manager"].includes(
        me.department
      );
    }
  },
  mounted() {
    this.loadReportCategories();
  },
  methods: {
    async loadReportCategories() {
      try {
        const response = await http.reportCategories.getMenuCategories();
        if (response.data.success) {
          this.reportCategories = response.data.categories || [];
        }
      } catch (error) {
        console.error("Rapor kategorileri yuklenemedi:", error);
      }
    },
    resetCache() {
      localStorage.removeItem("getOptionList");
    }
  }
};
</script>

<style>
.system-menu ul {
  margin: 0px;
  padding: 0px;
  padding: 10px;
}

.system-menu h3 {
  font-size: 20px;
  padding: 10px;
  margin: 0px;
}

.system-menu ul li {
  display: block;
  padding: 5px;
  border-radius: 5px;
}

.system-menu a {
  @apply text-gray-600;
}

.system-menu ul li:hover a {
  color: #222;
  text-decoration: none;
}

.system-menu ul li:hover {
  @apply bg-pampas;
}

.system-menu-title {
  color: #000;
  margin: 10px 5px;
}

.system-menu-title:hover {
  background: transparent !important;
}

.system-menu-subtitle {
  color: #666;
  margin: 8px 5px 4px 10px;
  font-size: 11px;
}

.system-menu-subtitle:hover {
  background: transparent !important;
}
</style>
